import { render, staticRenderFns } from "./ChooseProductPanel.vue?vue&type=template&id=27641321&"
import script from "./ChooseProductPanel.vue?vue&type=script&lang=ts&"
export * from "./ChooseProductPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports